import { render, staticRenderFns } from "./EvaluacionRespetoPrincipiosCardComponent.vue?vue&type=template&id=bbfba3aa"
import script from "./EvaluacionRespetoPrincipiosCardComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionRespetoPrincipiosCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports